import {formattedPropertyModel} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import * as React from 'react';

import styles from './PropertiesMap.less';
import {PropertiesMapItem} from './PropertiesMapItem';

interface OwnProps {
  dataObject: Record<string, any>;
  isTranslated?: boolean;
  hideEmpty?: boolean;
  mapByConfig?: boolean;
  noPadding?: boolean;
  propertiesConfig?: formattedPropertyModel.FormattedProperty[];
  propertiesConfigMap?: Record<
    string,
    formattedPropertyModel.FormattedProperty
  >;
  showBorders?: boolean;
}

type Props = OwnProps;

export const PropertiesMap: React.FC<Props> = (props) => {
  const {
    dataObject,
    isTranslated = false,
    hideEmpty = false,
    mapByConfig,
    noPadding = false,
    propertiesConfig,
    propertiesConfigMap,
    showBorders = true,
  } = props;

  return (
    <div className={styles.dlPropertiesMap} data-name={'mapWrapper'}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {mapByConfig
        ? !isEmpty(propertiesConfig) && !isEmpty(dataObject)
          ? propertiesConfig?.map((docProperty) => (
              <PropertiesMapItem
                key={docProperty.getProperty()}
                isTranslated={isTranslated}
                hideEmpty={hideEmpty}
                propertyConfig={docProperty}
                propertyValue={formattedPropertyModel.FormattedProperty.getObjectProperty(
                  dataObject,
                  docProperty.getProperty()
                )}
                noPadding={noPadding}
                showBorders={showBorders}
              />
            ))
          : null
        : Object.keys(dataObject)
            // eslint-disable-next-line arrow-body-style
            .map((propertyName) => {
              return !isEmpty(propertiesConfigMap) &&
                propertiesConfigMap[propertyName] ? (
                <PropertiesMapItem
                  key={propertyName}
                  isTranslated={isTranslated}
                  propertyConfig={propertiesConfigMap[propertyName]}
                  propertyValue={formattedPropertyModel.FormattedProperty.getObjectProperty(
                    dataObject,
                    propertyName
                  )}
                  noPadding={noPadding}
                  showBorders={showBorders}
                />
              ) : null;
            })}
    </div>
  );
};

PropertiesMap.displayName = 'PropertiesMap';
